import type { MenuButtonProps as ChakraMenuButtonProps } from '@chakra-ui/react';
import {
  MenuButton as ChakraMenuButton,
  useMenuStyles,
} from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type MenuButtonProps = OmitChakraProps<ChakraMenuButtonProps>;

export const MenuButton = withChakraAs<MenuButtonProps, 'button'>((props) => {
  const { buttonOverride } = useMenuStyles();

  // check for `as` to know when to use the style overrides due to some internal handling by chakra
  return (
    <ChakraMenuButton {...props} sx={props.as ? buttonOverride : undefined} />
  );
});
